import { morristownConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function MorristownPage() {
  return <CityPageTemplate config={morristownConfig} />;
}